import React from "react";
import { Box, Skeleton, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";

function KPICardSkeleton() {
  return (
    <Box
      sx={{
        position: "relative",
        borderRadius: "16px",
        background: "#FFFFFF",
        boxShadow: "0px 4px 12px 0px #00000014",
        padding: "24px 28px",
        overflow: "hidden",
        flex: 1,
        minWidth: 0,
        border: "1px solid #D9E1E7",
      }}
    >
      <Skeleton
        variant="text"
        width="60%"
        sx={{ fontSize: "14px", mb: 1.5 }}
      />
      <Box sx={{ display: "flex", alignItems: "baseline", gap: "10px" }}>
        <Skeleton
          variant="text"
          width="45%"
          sx={{ fontSize: "28px" }}
        />
        <Skeleton
          variant="text"
          width="15%"
          sx={{ fontSize: "20px" }}
        />
      </Box>
    </Box>
  );
}

function KPICard({ title, value, year, loading }) {
  if (loading) return <KPICardSkeleton />;
  const formatValue = (value) => {
    if (Array.isArray(value)) {
      return value.map((v) =>
        !isNaN(v)
          ? String(Math.ceil(Number(String(v).replace(/,/g, ""))))
          : String(v).replace(/,/g, ""),
      );
    }
    if (!isNaN(value)) {
      return String(Math.ceil(Number(String(value).replace(/,/g, ""))));
    }
    return String(value).replace(/,/g, "");
  };
  return (
    <Box
      sx={{
        position: "relative",
        borderRadius: "16px",
        background:
          "linear-gradient(135deg, #FFFFFF 70%, #1F36C7 125%, #1F36C7 100%)",
        boxShadow: "0px 4px 12px 0px #00000014",
        padding: "24px 28px",
        overflow: "hidden",
        flex: 1,
        minWidth: 0,
        border: "1px solid #D9E1E7",
      }}
    >
      <Typography
        sx={{
          fontSize: {
            lg: "14px",
            md: "10px",
            sm: "8px",
          },
          fontWeight: 500,
          color: "#667F93",
          mb: 1.5,
        }}
      >
        {title}
      </Typography>

      <Box sx={{ display: "flex", alignItems: "baseline", gap: "10px" }}>
        <Typography
          sx={{
            fontSize: {
              lg: "28px",
              md: "18px",
              sm: "14px",
            },
            fontWeight: 900,
            color: "#1F36C7",
            lineHeight: "160%",
          }}
        >
          {formatValue(value)}
        </Typography>
        {year && (
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: 400,
              color: "#667F93",
            }}
          >
            {year}
          </Typography>
        )}
      </Box>
    </Box>
  );
}

function SingleKPI({ title, value, year, items, loading, view }) {
  const location = useLocation();
  const isChatPage = location.pathname.startsWith("/samarth/chat");
  if (items && items.length > 0) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: location.pathname.startsWith("/samarth/chat")
            ? "row"
            : "column",
          gap: "16px",
          width:
            view === "dashboards"
              ? "100%"
              : isChatPage && items.length === 1
                ? "40%"
                : "100%",
        }}
      >
        {items.map((item, idx) => (
          <KPICard
            key={idx}
            title={item.title}
            value={item.value}
            year={item.year}
            loading={loading}
          />
        ))}
      </Box>
    );
  }

  // Single KPI mode
  return <KPICard title={title} value={value} year={year} loading={loading} />;
}

export default SingleKPI;
